import { FormattedMessage } from "react-intl";

export const getErrorMessage = (string) => {
  let errorString = string.trim();
  switch (errorString) {
    case "CustomerAlreadyExists": {
      return <FormattedMessage id="CustomerAlreadyExists" />;
    }
    case "EmailIsNotValid": {
      return <FormattedMessage id="EmailIsNotValid" />;
    }
    case "UrlAlreadyInUse": {
      return <FormattedMessage id="UrlAlreadyInUse" />;
    }
    case "IdentifierAlreadyInUse": {
      return <FormattedMessage id="IdentifierAlreadyInUse" />;
    }
    case "UserNameIsNotValid": {
      return <FormattedMessage id="UserNameIsNotValid" />;
    }
    case "ClassNotFound": {
      return <FormattedMessage id="ClassNotFound" />;
    }
    case "UserNotFound": {
      return <FormattedMessage id="UserNotFound" />;
    }
    case "FileNotFound": {
      return <FormattedMessage id="FileNotFound" />;
    }
    case "ModuleNotFound": {
      return <FormattedMessage id="ModuleNotFound" />;
    }
    case "CourseNotFound": {
      return <FormattedMessage id="CourseNotFound" />;
    }
    case "ModuleIsLocked": {
      return <FormattedMessage id="ModuleIsLocked" />;
    }
    case "FinalExamIsLocked": {
      return <FormattedMessage id="FinalExamIsLocked" />;
    }
    case "TeacherNotFound": {
      return <FormattedMessage id="TeacherNotFound" />;
    }
    case "CustomerNotFound": {
      return <FormattedMessage id="CustomerNotFound" />;
    }
    case "ProgramNotFound": {
      return <FormattedMessage id="ProgramNotFound" />;
    }
    case "TargetCustomerHasNoClasses": {
      return <FormattedMessage id="TargetCustomerHasNoClasses" />;
    }
    case "PriceListNotFound": {
      return <FormattedMessage id="PriceListNotFound" />;
    }
    case "SomeOrderItemsWereDuplicated": {
      return <FormattedMessage id="SomeOrderItemsWereDuplicated" />;
    }
    case "SomeStudentsHaveInvalidCombinations": {
      return <FormattedMessage id="SomeStudentsHaveInvalidCombinations" />;
    }
    case "NotAllStudentsWereFound": {
      return <FormattedMessage id="NotAllStudentsWereFound" />;
    }
    case "NotAllArticlesWereFound": {
      return <FormattedMessage id="NotAllArticlesWereFound" />;
    }
    case "NotAllArticlesWereLicenseArticles": {
      return <FormattedMessage id="NotAllArticlesWereLicenseArticles" />;
    }
    case "AplStepNotFound": {
      return <FormattedMessage id="AplStepNotFound" />;
    }
    case "AplComponentNotFound": {
      return <FormattedMessage id="AplComponentNotFound" />;
    }
    case "AplPointNotFound": {
      return <FormattedMessage id="AplPointNotFound" />;
    }
    case "AplStudentIdAttendanceIdMissMatch": {
      return <FormattedMessage id="AplStudentIdAttendanceIdMissMatch" />;
    }
    case "AplComponentCannotBeDeletedBecauseRegistrationsExists": {
      return (
        <FormattedMessage id="AplComponentCannotBeDeletedBecauseRegistrationsExists" />
      );
    }
    case "AplComponentCannotBeEditedBecauseRegistrationsExists": {
      return (
        <FormattedMessage id="AplComponentCannotBeEditedBecauseRegistrationsExists" />
      );
    }
    case "AplStepCannotBeDeletedBecauseRegistrationsExists": {
      return (
        <FormattedMessage id="AplStepCannotBeDeletedBecauseRegistrationsExists" />
      );
    }
    case "AplStepCannotBeEditedBecauseRegistrationsExists": {
      return (
        <FormattedMessage id="AplStepCannotBeEditedBecauseRegistrationsExists" />
      );
    }
    default: {
      return string;
    }
  }
};
